import { Avatar, Stack, Typography } from '@mui/material';
import { IParentCategory } from 'API/UniversalRequest/universalRequest';
import { useIsDesktop } from 'Hooks';

interface ISubjectListItem {
  category: IParentCategory;
  onClick: () => void;
  svgIcon: string;
}

export const ParentCategoriesListItem = ({
  category,
  onClick,
  svgIcon,
}: ISubjectListItem) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      width={isDesktop ? '274px' : '157px'}
      height={isDesktop ? '150px' : '128px'}
      alignItems='center'
      bgcolor='white'
      boxShadow='0px 4px 16px rgba(8, 30, 84, 0.12)'
      border='1px solid #B7CCFF'
      borderRadius='10px'
      sx={{ cursor: 'pointer' }}
      onClick={onClick}
      textAlign='center'
      p={isDesktop ? '0 40px' : '0 6px'}
      tabIndex={0}
    >
      {
        <Avatar
          src={svgIcon}
          alt=''
          sx={{
            mt: isDesktop ? '20px' : '10px',
            width: '48px',
            height: '48px',
          }}
        />
      }
      <Typography
        fontSize={isDesktop ? '24px' : '18px'}
        fontWeight='700'
        lineHeight='24px'
        mt={isDesktop ? '12px' : '6px'}
      >
        {category.title}
      </Typography>
    </Stack>
  );
};
